// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_1ahQ5fqRQjNFmlXQxSSVmD","marketText":"_3x8UWiP4sdXgcR4_NsG5AN","customButtonContainer":"_1vuLdFNdNSW6_4jwg3hipn","innerText":"_2Jzv2nK2pVPT7UgtgJry7E"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/baseball/css/oddsCardBaseball.css
// module id = 986
// module chunks = 0